import { useMutation, useQuery, useQueryClient } from 'react-query';
import { request } from '../utils/axios-utils';

const selectData = response => response?.data?.data;

function cleanParams(params) {
    const out = {};
    for (const [key, value] of Object.entries(params || {})) {
        if (value === undefined || value === null) continue;
        out[key] = value;
    }
    return out;
}

export function useRevenueDaily(params, enabled = true) {
    const query = cleanParams(params);
    return useQuery(['revenue', 'daily', query], () => request({ url: '/revenue/daily', method: 'GET', params: query }), {
        enabled: enabled && !!query.date,
        refetchOnWindowFocus: false,
        select: selectData,
    });
}

export function useRevenueItems(params, enabled = true) {
    const query = cleanParams(params);
    return useQuery(['revenue', 'items', query], () => request({ url: '/revenue/daily/items', method: 'GET', params: query }), {
        enabled: enabled && !!query.date,
        refetchOnWindowFocus: false,
        select: selectData,
    });
}

export function useRevenueRange(params, enabled) {
    const query = cleanParams(params);
    return useQuery(['revenue', 'range', query], () => request({ url: '/revenue/range', method: 'GET', params: query }), {
        enabled: enabled && !!query.from && !!query.to,
        refetchOnWindowFocus: false,
        select: selectData,
    });
}

export function fetchRevenueItems(params) {
    return request({ url: '/revenue/daily/items', method: 'GET', params: cleanParams(params) }).then(selectData);
}

export function useRecomputeRevenue() {
    const queryClient = useQueryClient();
    return useMutation(body => request({ url: '/revenue/recompute', method: 'POST', data: body }), {
        onSuccess: () => queryClient.invalidateQueries(['revenue']),
    });
}
